var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super-formula-container"},[_c('svg',{attrs:{"viewBox":"0 0 500 500","xmlns":"http://www.w3.org/2000/svg"}},[_c('polygon',{attrs:{"points":_vm.points,"fill":"none","stroke":"black"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }